import styled from 'styled-components';
import { fromMd, pageLayoutMaxWidth } from '../../../constants';
export const Grid = styled.div `
  margin: 0 auto;
  padding: 0 24px;

  ${fromMd} {
    max-width: ${pageLayoutMaxWidth};
    overflow: ${o => o.isFluid && 'hidden'};
    padding: ${o => (o.isFluid ? '0' : '0 72px')};
  }
`;
//# sourceMappingURL=index.js.map